module.exports = __webpack_public_path__ + "img/508-b92a3b.png";